export { assertFanUserNotBanned, FanUserBannedError } from './assertFanUserNotBanned';
export { authFetch } from './authFetch';
export { createAuthRetryInterceptor } from './authRetryInterceptor';
export {
  AUTH_TOKEN_CHANGED_EVENT,
  AUTH0_AUDIENCE,
  AUTH0_CLAIMS_EMAIL_KEY,
  AUTH0_CLAIMS_NAMESPACE,
  AUTH0_CONNECTION_DB,
  AUTH0_SCOPE,
  DEFAULT_POST_LOGIN_PATH,
  GRANT_TYPES,
  getAuth0ClientId,
  getAuth0Domain,
  LOGIN_METHODS,
  type LoginMethod,
  STORAGE_KEYS,
} from './constants';

export { clearMagicToken, getMagicToken, setMagicToken } from './magicToken';
export { decodeJwt, getTimeUntilExpiry, getTokenExpiryMs, isTokenExpired, shouldRefresh } from './tokenDecode';
export { clearResolverCache, resolveAccessToken, resolveToken } from './tokenResolver';
export {
  clearAuthTokens,
  getAccessToken,
  getBrandFromStorage,
  getLoginMethod,
  getRefreshToken,
  getUserId,
  isEmbedMode,
  notifyTokenChanged,
  removeAccessToken,
  removeLoginMethod,
  setAccessToken,
  setAuthInProgress,
  setLoginMethod,
  setUserId,
  storeTokenResponse,
} from './tokenStorage';
export type {
  FetchTokenFn,
  GetAccessTokenSilentlyFn,
  JwtPayload,
  MagicTokenResult,
  RefreshResult,
  TokenResolverDeps,
  TokenResponse,
} from './types';
